module.exports = __webpack_public_path__ + "officialStatic/img/new26.ab502ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new26.jpg
// module id = TLQx
// module chunks = 0